var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIconCamping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.723 18.434H19.66l-6.029-9.968.68-1.127a.545.545 0 0 0-.128-.744.507.507 0 0 0-.72.134l-.441.728-.024-.039-.023.039-.44-.728a.508.508 0 0 0-.72-.134.546.546 0 0 0-.131.744l.682 1.127-6.03 9.968H5.273A.28.28 0 0 0 5 18.72v.496a.28.28 0 0 0 .274.284H13v-6.945l3.848 6.945h3.877a.28.28 0 0 0 .276-.284v-.496a.282.282 0 0 0-.277-.286z"
  })));
}
export default SvgMarkerIconCamping;